import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    accountList: [],
    roles: [],
    limit: 10,
    page: 1,
    pageCount: 1 || (JSON.parse(window.localStorage.getItem('accountPage'))),
    openDetail: false,
    accountDetail: {
        id: null,
        role: null,
        username: "",
        name: "",
        password: "",
        passwordConfirm: "",
    },
}

const account = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setAccountList(state, action) {
            state.accountList = action.payload;
        },
        setRoles(state, action) {
            state.roles = action.payload;
        },
        setPage(state, action) {
            state.page = action.payload;
        },
        setOpenDetail(state, action) {
            state.openDetail = action.payload;
        },
        setAccountDetail(state, action) {
            state.accountDetail = action.payload;
        },
    }
})

export const accountActions = account.actions;
export default account;